import React from 'react'
import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import './EmptyFolder.scss'

const EmptyFolder = () => {
  const { t } = useTranslation()

  return (
    <div className="empty-folder">
      <Empty
        description={t('v5:this_folder_is_empty')}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    </div>
  )
}

export default EmptyFolder
